import React from 'react';
import { TableBody } from '@material-ui/core';
import TableComponent from '../../DesignSystem/Table';
import { priceRowType, TableConstants } from '../../../utils/appConstants';
import LoadingRow from '../../DesignSystem/Table/Rows/LoadingRow';
import EmptyRow from '../../DesignSystem/Table/Rows/EmptyRow';
import PriceRow from './row';
import PriceRowGroup from './groupRow';
import { priceTableHeadCells } from '../headers';

interface TableProps {
  priceRow: priceRowType[];
  loading: boolean;
}

const Table: React.FC<TableProps> = ({
  priceRow, loading,
}) => {
  const headCells = priceTableHeadCells;
  let rows;
  if (loading) {
    rows = <LoadingRow colSpan={headCells.length + 1} />;
  } else if (priceRow.length === 0) {
    rows = <EmptyRow text={TableConstants.noRecordsFound} colSpan={headCells.length + 1} />;
  } else {
    const priceRowGroups: priceRowType[][] = [];
    priceRow.forEach((row) => {
      if (row) {
        if (!(row.row?.resourceId)) {
          priceRowGroups.push([row]);
        } else {
          const index = priceRowGroups.findIndex((temp: priceRowType[]) => (
            (temp[0].row?.resourceId === row.row?.resourceId)));
          if (index === -1) {
            priceRowGroups.push([row]);
          } else {
            priceRowGroups[index].push(row);
          }
        }
      }
    });
    const priceRows = priceRowGroups.map((obj: any, index) => {
      if (obj.length > 1) return <PriceRowGroup priceRows={obj} key={index} />;
      return <PriceRow priceRow={obj[0]} key={index} />;
    });
    rows = (
      <TableBody>
        {priceRows}
      </TableBody>
    );
  }

  return (
    <TableComponent
      rowCount={priceRow.length}
      headCells={headCells}
      rowSelectionAvailable={false}
      numSelected={0}
      rows={rows}
      totalPages={1}
      page={1}
      onPageChange={() => {}}
    />
  );
};

export default Table;
